
import { mealCompositionQueryService } from "./mealCompositionQueryService";
import { mealCompositionMutationService } from "./mealCompositionMutationService";
import { mealCompositionTagService } from "./mealCompositionTagService";

// Export individual services
export { mealCompositionQueryService } from "./mealCompositionQueryService";
export { mealCompositionMutationService } from "./mealCompositionMutationService";
export { mealCompositionCrudService } from "./mealCompositionCrudService";
export { mealCompositionRecipeService } from "./mealCompositionRecipeService";
export { mealCompositionTagService } from "./mealCompositionTagService";

/**
 * Consolidated meal composition service that combines query and mutation services
 */
export const mealCompositionService = {
  // Query methods
  getMealCompositions: mealCompositionQueryService.getMealCompositions,
  getMealCompositionById: mealCompositionQueryService.getMealCompositionById,
  getMealCompositionsByIds: mealCompositionQueryService.getMealCompositionsByIds,
  
  // Mutation methods
  createMealComposition: mealCompositionMutationService.createMealComposition,
  updateMealComposition: mealCompositionMutationService.updateMealComposition,
  deleteMealComposition: mealCompositionMutationService.deleteMealComposition,
  addRecipeToComposition: mealCompositionMutationService.addRecipeToComposition,
  removeRecipeFromComposition: mealCompositionMutationService.removeRecipeFromComposition,
  
  // Tag methods
  generateCompositionTags: mealCompositionTagService.generateCompositionTags,
  updateCompositionTags: mealCompositionTagService.updateCompositionTags,
  generateAndSaveCompositionTags: mealCompositionTagService.generateAndSaveCompositionTags,
};

// Export default for consistency with other service modules
export default mealCompositionService;
